import { useAppDispatch } from "@/hooks";
import { auth } from "@/lib/firebase";
import { setUser } from "@/store/appSlice";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [title, setTitle] = useState(document.title);

  const logout = () => {
    auth.signOut()
      .then(() => {
        dispatch(setUser(null))
        navigate('/login')
      })
      .catch((error) => {
        console.error("Error signing out: ", error);
      });
  }

  useEffect(() => {
    if (location.pathname === '/dashboard') {
      setTitle("ダッシュボード");
    }
    if (location.pathname === '/users') {
      setTitle("ユーザー管理");
    }
    if (location.pathname === '/settings/admins') {
      setTitle("管理者管理");
    }
    if (location.pathname === '/content') {
      setTitle("学習コンテンツ管理");
    }
    if (location.pathname === '/settings/service-setting') {
      setTitle("サービス管理");
    }
    if (location.pathname === '/settings/update-password') {
      setTitle("パスワード変更");
    }
    if (location.pathname.includes('/users/')) {
      setTitle("ユーザー詳細");
    }
  }, [location.pathname]);

  return <header className="header">
    <div className="header-content">
      <nav className="navbar navbar-expand">
        <div className="collapse navbar-collapse justify-content-between">
          <div className="header-left">
            <div className="dashboard_bar">
              {title}
            </div>
          </div>
          <ul className="navbar-nav header-right">
            <li className="nav-item dropdown header-profile">
              <a className="nav-link" href="#" role="button" data-bs-toggle="dropdown">
                <img src="/images/avatar.jpg" width="20" alt="" />
                <div className="header-info">
                  <span className="text-black"><strong>Key Link</strong></span>
                  <p className="fs-12 mb-0">Super Admin</p>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                <a onClick={logout} href="#" className="dropdown-item ai-icon">
                  <svg id="icon-logout" xmlns="http://www.w3.org/2000/svg" className="text-danger" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                  <span className="ms-2">Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
}

export default Header
